import { Box, SxProps } from '@mui/material';
import wfgpsIcon from '../../images/wfgpsIcon.svg'
import { useNavigate } from 'react-router-dom';

interface SiteIconProps {
  width?: string;
  sx?: SxProps;
  onClick?: () => void;
}

export const SiteIcon = ({ width = '40px', sx, onClick }: SiteIconProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate('/');
    }
  };

  return (
    <Box
      component="div"
      onClick={handleClick}
      sx={{ 
        cursor: 'pointer',
        alignSelf: 'flex-start',
        paddingTop: '10px',
        paddingLeft: '5px',
        width: '100%',
      }}
    >
      <img
        src={wfgpsIcon}
        alt='App Logo'
        style={{
          width,
          maxWidth: width,
          backgroundColor: 'transparent',
        }}
      />
    </Box>
  );
}; 